import { render, staticRenderFns } from "./OrdenCompraModelAddComponent.vue?vue&type=template&id=996ac84c&"
import script from "./OrdenCompraModelAddComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraModelAddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports